import api from './api'

async function fetchCustomer() {
  return await api.get('/customer').then(({data}) => data.data)
}

async function login(data) {
  return await api.post('/customer/login', data).then(({ data }) => data.data)
}

async function register(data) {
  return await api.post('/customer/register', data).then(({ data }) => data.data)
}

async function logout() {
  return await api.post('/customer/logout')
}

export { fetchCustomer, login, register, logout }
